import { GoogleBusinessConnectionOptions } from '../../../../../modals/live-orders/LiveOrdersDrawer';

export default {
  titles: {
    disable: '¿Seguro que quieres desactivar los pedidos en vivo?',
    enable: '¿Seguro que quieres activar los pedidos en vivo?',
  },
  form: {
    is_google_business_available: {
      label: 'Google Business disponible',
    },
    is_smart_pricing_configured: {
      label: 'Precios más bajos que Lieferando, Wolt, Uber',
    },
    is_flyers_package_sent: {
      label: 'Flyer promocional enviado',
    },
    is_menu_fully_configured: {
      label: 'Todos los productos del menú disponibles',
    },
    has_offers_on_competitor_platforms: {
      label: '¿El restaurante tiene ofertas activas en Wolt, Uber, Lieferando (excepto envío gratuito)?',
    },
    is_instagram_story_shared: {
      label: 'Historia de Instagram compartida con el propietario',
    },
    is_order_system_connected_to_website: {
      label: 'Web de Foodamigos conectada O botón de pedido online en web propia del restaurante',
    },
    google_business_connected_by: {
      label: '¿Cómo obtuvimos acceso al Perfil de Google Business?',
      options: {
        [GoogleBusinessConnectionOptions.SalesManagerOverEmail]:
          'El responsable de ventas invitó a google@foodamigos.io',
        [GoogleBusinessConnectionOptions.SalesManagerOverPhone]:
          'El responsable de ventas envió la primera solicitud desde el teléfono del propietario',
        [GoogleBusinessConnectionOptions.OnboardingManagerOverEmail]:
          'El responsable de incorporación solicitó el perfil de Google Business (el responsable de ventas no invitó ni solicitó acceso)',
      },
    },
  },
  labels: {
    successful_launch:
      'Para garantizar un lanzamiento exitoso, revisa y resuelve los siguientes puntos pendientes. Verificar \n' +
      'esta información ayudará a evitar posibles problemas cuando el restaurante esté en vivo.',
    check_errors: 'Revisa los errores para garantizar un buen lanzamiento del restaurante.',
    checkbox_confirmation:
      'Confirmo que he revisado los errores y doy mi consentimiento para la activación de este restaurante.',
  },
  buttons: {
    check_error: 'Ver error',
    confirm_and_activate: 'Confirmar y activar',
    cancel: 'Cancelar',
    yes: 'Sí',
    no: 'No',
  },
  errors: {
    name: {
      title: 'Sin caracteres árabes, chinos, etc. en el nombre de la tienda',
      description: 'El nombre de la tienda online incluye caracteres no ingleses (no latinos)',
    },
    logo_url: {
      title: 'Logo',
      description: 'El logo se ha subido a la tienda online',
    },
    pictures: {
      title: 'Imagen de galería',
      description: '≥ 1 imagen de galería disponible en la tienda online',
    },
    menu_uploaded: {
      title: 'Menú subido',
      description: '≥ 1 menú disponible',
    },
    opening_hours: {
      title: 'Horario de apertura',
      description: '≥ 1 horario de apertura añadido',
    },
    address: {
      title: 'Dirección del restaurante',
      description: 'Calle, ciudad, código postal introducidos',
    },
    upsell_items: {
      title: 'Artículos de venta adicional',
      description: '≥ 3 artículos de venta adicional seleccionados',
    },
    master_promo_code: {
      title: 'Código promocional maestro',
      description: 'El código promocional maestro está disponible',
    },
    flyers_ordered: {
      title: 'Flyers pedidos',
      description: '≥ 1 paquete de flyers pedido',
    },
    test_orders: {
      title: 'Pedido de prueba enviado',
      description: '≥ 1 pedido de prueba realizado',
    },
    stripe_billing: {
      title: 'Cuenta Stripe',
      description: 'Cuenta Stripe conectada',
    },
    payments_configured: {
      title: 'Pagos configurados',
      description: 'El socio ha conectado un proveedor de pago — obligatorio antes del lanzamiento',
    },
    adyen_merchant_account: {
      title: 'Cuenta de comerciante de Adyen',
      description:
        'Una cuenta de comerciante activa para el país de este restaurante, necesaria para las tarifas de tarjetas nacionales',
    },
    payment_rail_covers_country: {
      title: 'El canal de pago cubre el país',
      description: 'Las cuentas de pago del partner pueden procesar el país de este restaurante',
    },
    identity: {
      title: 'Identidad del restaurante',
      description: 'El tipo de restaurante y la cocina han sido configurados',
    },
    storefront: {
      title: 'Tienda creada y dominio conectado',
      description: 'Solo si el restaurante quiere usar nuestra web',
    },
    google_business: {
      title: 'Google Business',
      description: 'Google Business conectado',
    },
    billing_payment_method: {
      title: 'Método de pago',
      description: 'Añade un método de pago para que FoodAmigos pueda facturar mensualmente a este restaurante.',
    },
    billing_license: {
      title: 'Licencia',
      description: 'Este restaurante necesita un Plan Partner antes de poder activarse.',
    },
    business_name: {
      title: 'Nombre de la empresa / del restaurante',
      description: 'Se ha guardado el nombre que aparece en las condiciones de uso y la política de privacidad',
    },
    payment_method: {
      title: 'Efectivo o pagos en línea',
      description: 'El pago en efectivo al retirar o entregar está activado, o los pagos en línea están verificados',
    },
    stripe_processing_fee: {
      title: 'Comisión de procesamiento',
      description: 'El partner ha establecido su comisión de procesamiento de Stripe o ha confirmado un margen del 0 %',
    },
  },
};
